import request from "@/utils/request";

const dygBaseUrl = process.env.VUE_APP_DYG_BASE_URL;

// 获取语言包版本号
export const getLangVersion = (params) =>
	request.get("/apc/language.translation/version", params, { baseURL: dygBaseUrl });

// 获取语言包
export const getLangJson = (params) => request.get("/apc/language.translation/json", params, { baseURL: dygBaseUrl });
